<template>
  <!-- Close case-folders-line -->
  <div class="case-posta section">
    <div class="section-title">{{ $t("components.case_page_communication.title") }}</div>
    <div class="section-square kreiraj-spis" @click="newFilePop = true" v-if="permission">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="39"
        viewBox="0 0 50 39"
      >
        <g>
          <g>
            <path
              fill="#b8b8c1"
              d="M39.755 5.772a.71.71 0 0 1 0 1.001L25.391 21.224a4.727 4.727 0 0 1-3.364 1.4 4.729 4.729 0 0 1-3.364-1.4L4.3 6.774a.71.71 0 0 1 0-1.002.7.7 0 0 1 .996 0l14.363 14.45a3.34 3.34 0 0 0 4.737 0L38.76 5.773a.7.7 0 0 1 .995 0zm-38.369.234v22.205c0 2.111 1.708 3.83 3.807 3.83h29.324v1.417H5.193c-2.875 0-5.215-2.354-5.215-5.247V6.006C-.022 3.113 2.318.76 5.193.76h33.67c2.875 0 5.214 2.354 5.214 5.247v17.761H42.67V6.007c0-2.113-1.708-3.83-3.807-3.83H5.193c-2.1 0-3.807 1.718-3.807 3.83zm35.43 26.587c0-.435.35-.787.783-.787h4.805v-4.834c0-.434.351-.786.783-.786.432 0 .782.352.782.786v4.834h4.806c.432 0 .782.352.782.787 0 .434-.35.786-.782.786H43.97v4.834c0 .435-.35.787-.782.787a.785.785 0 0 1-.783-.787V33.38H37.6a.785.785 0 0 1-.783-.786z"
            />
          </g>
        </g>
      </svg>
      <div>{{ $t("components.case_page_communication.add_new") }}</div>
    </div>
    <div v-if="fetching" class="center-spinner">
        <svg class="dot-spin" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
    </div>
    <div v-else class="case-posta-item" v-for="(doc, key) in all_docs.slice(0,4)" :key="key" @click="openPreview(doc)" @dblclick="openPreview(doc)">
      <img class="doc-icon" src="@/assets/img/pdf_icon.svg" />
      <v-tooltip v-if="doc.name.length > 12" bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  {{ doc.name.slice(0,12) }}...
                </div>
              </template>
                {{ doc.name }}
      </v-tooltip>
      <div v-else>{{doc.name}}</div>
    </div>
    <div class="case-posta-sve pogledaj-sve" @click="changeView('posta')">{{ $t("components.case_page_communication.show_all") }}</div>

    <FilePreviewModal
      v-model="previewVisible"
      :fileItem="previewFile"
      :groupId="$route.params.uid"
    />

    <v-dialog v-model="newFilePop" width="540">
      <v-card class="dodaj-datoteku-popup">
        <v-card-title class="headline grey lighten-2" id="main-file-upload">
          {{ $t("components.case_page_communication.popup.title") }}
        </v-card-title>
        <div>
          <div class="flex w-full h-screen items-center justify-center text-center drop-document-main-wrapper" id="app">
            <div
              class="p-12 bg-gray-100 border border-gray-300"
              @dragover="dragover"
              @dragleave="dragleave"
              @drop="drop"
            >
              <div class="loading-spinner"></div>
              <input
                type="file"
                multiple
                name="fields[assetsFieldHandle][]"
                id="assetsFieldHandle"
                class="w-px h-px opacity-0 overflow-hidden absolute drag-drop"
                @change="onChange"
                ref="file"
                accept=".pdf"
              />

              <label
                for="assetsFieldHandle"
                class="block cursor-pointer drop-document-area"
              >
                <div>
                  <div class="select-file-message-wrapper">
                    <div class="select-file-message">
                      {{ $t("components.case_page_communication.popup.upload_text") }}
                    </div>
                  </div>
                  <div class="button-select-file-wrapper">
                    <div class="button-default button-select-file">
                      {{ $t("components.case_page_communication.popup.choose") }}
                    </div>
                  </div>
                </div>
              </label>
              <div class="opening-folder opening-radni-dokumenti section">
                <div class="inside-radni-dokumenti">
                  <draggable
                    :class="filelist.length > 3 ? 'row-multiple' : 'row'"
                    :sort="false"
                  >
                    <div v-for="upFile in filelist" :key="upFile.id">
                      <div
                        :class="[
                          filelist.length > 3
                            ? 'radni-dokument-inside-multiple'
                            : 'radni-dokument-inside',
                          'preneseni-dokument',
                        ]"
                        draggable="true"
                      >
                        <div
                          :class="[
                            filelist.length > 3
                              ? 'document-image-wrapper-multiple'
                              : 'document-image-wrapper',
                          ]"
                        >
                          <img
                            class="preneseni-dokument-image"
                            :src="returnFileType(upFile.name)"
                          />
                          <div
                            v-show="filelist.length < 4"
                            class="remove-document"
                            @click="deleteFileInSpis(upFile)"
                          >
                            <span>X</span>
                          </div>
                        </div>
                        <div class="preneseni-dokument-title">
                          {{ upFile.name }}
                        </div>

                        <div
                          v-show="filelist.length > 3"
                          class="remove-document-multiple"
                          @click="deleteFileInSpis(upFile)"
                        >
                          <span>X</span>
                        </div>
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-card-actions>
          <div class="button-upload-wrapper">
            <div
              class="button-default button-create"
              @click="addNewUploadFile()"
            >
              {{ $t("components.case_page_communication.popup.upload") }}
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

  <!-- Close case-posta -->
</template>

<script>
import auth from "@/services/auth";
import share from "@/apiCallers/promise_handler_db/sharepoint";
import draggable from "vuedraggable";
import gsap from "gsap";
import graph from "@/services/graph.js";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import FilePreviewModal from "@/components/generalComponents/FileViewer/FilePreviewModal.vue";


export default {
  components: {
    draggable,
    FilePreviewModal,
  },
  props: {
    ulazni_id: {
      type: String,
      required: true,
      default: null,
      smjer: true,
    },
    permission :{
      type : Boolean,
      default : true
    }
  },
  data() {
    return {
      all_docs: [],
      accessToken: "",
      filelist: [],
      newFilePop: false,
      fetching:true,
      previewVisible: false,
      previewFile: null,
    };
  },
  watch:{
    ulazni_id: async function(){
      try{
        await this.getAllDocsById(this.ulazni_id);
        // Only reverse if we have docs
        if (this.all_docs && this.all_docs.length > 0) {
          this.all_docs = this.all_docs.reverse();
        }
      }catch(error){
        console.log("[HomepageComunication] Error while getting docs:", error);
      }
    }
  },
  async created() {
    this.accessToken = this.$store.state.aToken 
    
  },
  methods: {
    // DELETE ALL FILES IN SPIS
    deleteFileInSpis(file) {
      this.filelist = this.filelist.filter((f) => f != file);
    },
    // RETURN APPROPRIATE FILE ICON
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext].toLowerCase();
      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xls":
          return_val = require("@/assets/img/xls_icon.svg");
          break;

        default:
          return_val = require("@/assets/img/doc_icon.svg");
          break;
      }
      return return_val;
    },
    // Add some visual fluff to show the user can drop its files
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
        gsap.to(".loading-spinner", 0, { display: "block" });
        gsap.to(".loading-spinner", 0.5, { opacity: 1 });
        gsap.to(".drop-document-area", 0.5, {
          filter: "blur(3px)",
          opacity: 0.7,
        });
      }
    },
    // Clean up after cursor leaves
    dragleave(event) {
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    //EVENT following dropping the files in area
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      //
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },

    //Open file that is clicked on
    openFile(linkToFile) {
      window.open(linkToFile);
    },
    openPreview(doc) {
      this.previewFile = doc;
      this.previewVisible = true;
    },
    //EVENT following dropping the files in area
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      //
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    // Reaction to event drop, that checks and controls all data
    onChange() {
      //check all the inserted files and remove all that don't comply with pdf format START
      let tmp_file_list = [...this.$refs.file.files];
      tmp_file_list = tmp_file_list.filter((p) => {
        let tmp_name_list = p.name.split(".");
        return tmp_name_list[tmp_name_list.length - 1].toLowerCase().includes("pdf");
      });
      //check all the inserted files and remove all that don't comply with pdf format END
      tmp_file_list.forEach((p) => {});
      this.filelist = this.filelist.concat(tmp_file_list);
    },
    async getAllDocsById(sid) {
      var ret_files = [];

      // Debug logging
      console.log('[HomepageComunication] getAllDocsById called:', {
        sid: sid,
        groupId: this.$route.params.uid,
        hasToken: !!this.$store.state.aToken,
        tokenLength: this.$store.state.aToken ? this.$store.state.aToken.length : 0
      });

       await graph
        .getFileChildren(this.$route.params.uid, sid)
        .then((response) => {
          console.log('[HomepageComunication] getFileChildren response:', {
            hasResponse: !!response,
            hasValue: response && !!response.value,
            valueLength: response && response.value ? response.value.length : 0
          });

          this.fetching = false;
          if (response && response.value) {
            response.value.forEach((dat) => {
              if(dat.name.toString().endsWith("pdf"))
              ret_files.push(dat);
            });
          }
          this.all_docs = ret_files;

        }).catch((error) => {
          console.error('[HomepageComunication] getFileChildren FAILED:', {
            error: error.message,
            status: error.status,
            sid: sid,
            groupId: this.$route.params.uid,
            tokenExists: !!this.$store.state.aToken
          });
          throw error;
        });
      
    },
    async addNewUploadFile() {
      const formData = new FormData();

      this.filelist.forEach((fl) => {
        formData.append("files", fl);
      });

      formData.append("token", this.accessToken);
      formData.append("groupId", this.$route.params.uid);
      formData.append("sid", this.ulazni_id);
      // formData.append("name", esc_filename);
      // appending file

      share.addDocumentInSpis(formData).then(async () => {
        await this.getAllDocsById(this.ulazni_id);
        this.all_docs = this.all_docs.reverse();
        this.newFilePop = false;
      });
    },
    changeView(nastavak) {
        this.$router.push("/case/" + this.$route.params.uid + "/"+nastavak);
    },
  },
};
</script>

<style>
</style>